import {
  AtSign,
  Bell,
  CalendarClock,
  ClipboardCheck,
  Gift,
  MessageSquareWarning,
  WalletCards,
} from "lucide-react";

const getNotificationVisual = (notification = {}) => {
  const content = [
    notification.type,
    notification.title,
    notification.message,
  ].join(" ").toLowerCase();

  if (/(payroll|payslip|salary|compensation)/.test(content)) {
    return { Icon: WalletCards, classes: "bg-emerald-50 text-emerald-600" };
  }
  if (/(query|disciplinary|absence|late attendance)/.test(content)) {
    return { Icon: MessageSquareWarning, classes: "bg-amber-50 text-amber-600" };
  }
  if (/(mention|tagged|comment|reply)/.test(content)) {
    return { Icon: AtSign, classes: "bg-violet-50 text-violet-600" };
  }
  if (/(request|approval|approved|declined|leave)/.test(content)) {
    return { Icon: ClipboardCheck, classes: "bg-blue-50 text-[#1234CD]" };
  }
  if (/(attendance|check.?in|check.?out|shift|schedule)/.test(content)) {
    return { Icon: CalendarClock, classes: "bg-cyan-50 text-cyan-600" };
  }
  if (/(birthday|anniversary|celebrat|reward|recognition)/.test(content)) {
    return { Icon: Gift, classes: "bg-rose-50 text-rose-600" };
  }
  if (/(wallet|airtime|data purchase|withdrawal|fund)/.test(content)) {
    return { Icon: WalletCards, classes: "bg-emerald-50 text-emerald-600" };
  }
  return { Icon: Bell, classes: "bg-slate-100 text-slate-600" };
};

export default function NotificationTypeIcon({ notification, className = "" }) {
  const { Icon, classes } = getNotificationVisual(notification);
  return (
    <span
      aria-hidden="true"
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${classes} ${className}`}
    >
      <Icon className="h-5 w-5" />
    </span>
  );
}
